module.exports = __webpack_public_path__ + "static/media/p4.c04a595d.webp";